/**
 * update descendants
 */
export function updateInherit(oldValue, newValue, o, service, name) {
  o.children.forEach(function (child) {
    if (child.getAttribute(name) === 'inherit') {
      child.parsedStyle[name] = newValue;
      var oldParsedValue = child.parsedStyle[name];
      child.updateStyleProperty(name, oldParsedValue, newValue);
    }
  });
}
export function computeInheritStyleProperty(child, name) {
  var ascendant = child.parentElement;

  while (ascendant) {
    if (ascendant.getAttribute(name) !== 'inherit' && ascendant.parsedStyle.hasOwnProperty(name)) {
      return ascendant.parsedStyle[name];
    }

    ascendant = ascendant.parentElement;
  }

  return null;
}